import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import RightsLibrary from './pages/RightsLibrary';
import PodcastCentre from './pages/PodcastCentre';
import CaseStories from './pages/CaseStories';
import News from './pages/News';
import Contact from './pages/Contact';
import Register from './pages/Register';
import AdminRegister from './pages/AdminRegister';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MembershipPolicy from './pages/MembershipPolicy';
import HowWeWork from './pages/HowWeWork';
import Volunteer from './pages/Volunteer';
import EmployerComplaint from './pages/EmployerComplaint';
import NotFound from './pages/NotFound';

import MemberDashboard from './pages/member/Dashboard';
import MyMembership from './pages/member/MyMembership';
import MyCases from './pages/member/MyCases';
import Documents from './pages/member/Documents';
import Messages from './pages/member/Messages';
import Appointments from './pages/member/Appointments';
import Referral from './pages/member/Referral';

import AdminDashboard from './pages/admin/AdminDashboard';

function App() {
  return (
    <div className="app-shell">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/rights-library" element={<RightsLibrary />} />
          <Route path="/podcast" element={<PodcastCentre />} />
          <Route path="/case-stories" element={<CaseStories />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/employer-complaint" element={<EmployerComplaint />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/register" element={<AdminRegister />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/membership-policy" element={<MembershipPolicy />} />
          <Route path="/how-we-work" element={<HowWeWork />} />

          <Route path="/member/dashboard" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
          <Route path="/member/membership" element={<ProtectedRoute><MyMembership /></ProtectedRoute>} />
          <Route path="/member/cases" element={<ProtectedRoute><MyCases /></ProtectedRoute>} />
          <Route path="/member/documents" element={<ProtectedRoute><Documents /></ProtectedRoute>} />
          <Route path="/member/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/member/appointments" element={<ProtectedRoute><Appointments /></ProtectedRoute>} />
          <Route path="/member/referral" element={<ProtectedRoute><Referral /></ProtectedRoute>} />

          <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
